import { CONST } from "../sideTypes"
import { MenuItemCategory, MenuItemType } from "../../Components/navigationTypes"


export const clientPortalList: () => Array<MenuItemType> =
    () => {
        return [
            ClientPortal,
            ClientTasks,
            RemoteClosing
        ];
    }

const ClientPortal: MenuItemType =
{
    label: "ClientConnect",
    navigate: {
        component: "main",
        url: "lfmaster.asp",
    },
    subItems: [
        {
            label: "Client Intake Information",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalState: 'ClientIntake'
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
        {
            label: "Document Exchange",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalState: 'DocumentExchange'
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
    ],
    addOptions: [],
    type: MenuItemCategory.Heading
}

const ClientTasks: MenuItemType =
{
    label: "Client Tasks",
    navigate: {
        component: "main",
        url: "lfmaster.asp",
    },
    subItems: [
        {
            label: "Client Retainer",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalModalType: 'clientretainer'

                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
        {
            label: "Identity Verification",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalModalType: 'idverification'
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
            appCode: ['RPW', 'RPWBC', 'RPWMB', 'RPWNS', 'RPWSK']
        },
        {
            label: "Source of Funds",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalModalType: 'sourceoffunds'
                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Contract
        },
    ],
    addOptions: [],
    type: MenuItemCategory.Heading
}

const RemoteClosing: MenuItemType =
{
    label: "E-Signing",
    navigate: {
        component: "main",
        url: "lfmaster.asp",
    },
    subItems: [
        {
            label: "Manage Session",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                    clientPortalState: 'esigning'

                },
                reactFrame: 'CLIENTPORTAL'
            },
            addOptions: [],
            type: MenuItemCategory.Default,
        },
    ],
    addOptions: [],
    type: MenuItemCategory.Heading
}
